import { Button } from '@/components/shadcn/button'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { IconV2FormOutline } from '@icons/IconV2FormOutline'

interface IndexPanelActionsProps {
  canEditIndex: boolean
  isReorderMode: boolean
  isSaving: boolean
  onEnterReorderMode: () => void
  onSave: () => void
  onCancel: () => void
  onAdd: () => void
}

export function IndexPanelActions({
  canEditIndex,
  isReorderMode,
  isSaving,
  onEnterReorderMode,
  onSave,
  onCancel,
  onAdd,
}: IndexPanelActionsProps) {
  if (isReorderMode) {
    return (
      <div className="flex items-center justify-end gap-2">
        <Button size="sm" onClick={onSave} disabled={isSaving}>
          {isSaving ? 'Saving...' : 'Save'}
        </Button>
        <Button size="sm" variant="outline" onClick={onCancel} disabled={isSaving}>
          Cancel
        </Button>
        <Button size="sm" variant="outline" onClick={onAdd} disabled={isSaving}>
          Add
        </Button>
      </div>
    )
  }

  if (!canEditIndex) {
    return null
  }

  return (
    <div className="flex justify-end">
      <TooltipButton tooltip="Edit Index">
        <Button size="icon" variant="ghost" className="size-8" onClick={onEnterReorderMode}>
          <IconV2FormOutline className="size-4" />
        </Button>
      </TooltipButton>
    </div>
  )
}
